import React from "react";
import { useCustomAlertStore } from "../../Store/store";
import { ChangeMemberStatus } from "../../api/userManagementAPI";
import {
  TableRow,
  TableCell,
  StatusBadge,
  ButtonContainer,
  Button,
} from "../styled/userManagement/UserManageStyle";

export default function MemberTBody({ member, index, onDataChange }) {
  const { showSuccessAlert, showErrorAlert, showConfirmAlert } =
    useCustomAlertStore();

  const handleApprove = async () => {
    showConfirmAlert(
      "회원 승인",
      `${member.userName} 회원을 승인하시겠습니까?`,
      async () => {
        try {
          // TODO: API 호출
          const response = await ChangeMemberStatus(member.userName, 1);

          showSuccessAlert("승인 완료", "회원이 승인되었습니다.");
          onDataChange();
        } catch (error) {
          console.error("승인 실패:", error);
          showErrorAlert("승인 실패", "회원 승인에 실패했습니다.");
        }
      },
    );
  };

  const handleSuspend = async () => {
    showConfirmAlert(
      "회원 탈퇴",
      `${member.userName} 회원을 탈퇴 처리하시겠습니까?`,
      async () => {
        try {
          // TODO: API 호출
          const response = await ChangeMemberStatus(member.userName, 2);

          showSuccessAlert("탈퇴 완료", "회원이 탈퇴 처리되었습니다.");
          onDataChange();
        } catch (error) {
          console.error("탈퇴 실패:", error);
          showErrorAlert("탈퇴 실패", "회원 탈퇴 처리에 실패했습니다.");
        }
      },
    );
  };

  const getStatusText = (status) => {
    switch (`${status}`) {
      case "1":
        return "승인";
      case "2":
        return "거절";
      case "3":
        return "대기";
      default:
        return status || "대기";
    }
  };

  const getStatusClass = (status) => {
    switch (`${status}`) {
      case "1":
        return "approved";
      case "2":
        return "rejected";
      case "3":
        return "pending";
      default:
        return status || "pending";
    }
  };

  return (
    <TableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{member.userName || "-"}</TableCell>
      <TableCell>{member.company.name || "-"}</TableCell>
      <TableCell>
        {member.updatedAt
          ? member.updatedAt.split("T")[0]
          : member.createdAt
            ? member.createdAt.split("T")[0]
            : "-"}
      </TableCell>
      <TableCell>
        <StatusBadge className={getStatusClass(member.userStatus)}>
          {getStatusText(member.userStatus)}
        </StatusBadge>
      </TableCell>
      <TableCell>
        <ButtonContainer>
          <Button
            className="approve-button"
            disabled={
              `${member.userStatus}` === "1" || `${member.userStatus}` === "3"
            }
            onClick={handleApprove}
          >
            승인
          </Button>
          <Button
            className="reject-button"
            disabled={
              `${member.userStatus}` === "3" || `${member.userStatus}` === "2"
            }
            onClick={handleSuspend}
          >
            탈퇴
          </Button>
        </ButtonContainer>
      </TableCell>
    </TableRow>
  );
}
